module.exports = __webpack_public_path__ + "img/haywirethumb.6d009de6.gif";